/**
 * Maximum geofencing area, in square kilometers, that the embeddings search API can process.
 * Requests over this area fail server-side, so the UI blocks them up front.
 */
export const MAX_GEOFENCING_AREA_SQUARE_KILOMETERS = 1_000_000;

/** {@link MAX_GEOFENCING_AREA_SQUARE_KILOMETERS} expressed in square meters. */
export const MAX_GEOFENCING_AREA_SQUARE_METERS = MAX_GEOFENCING_AREA_SQUARE_KILOMETERS * 1_000_000;

/** Short label shown on disabled search controls when no geofencing has been configured. */
export const GEOFENCING_REQUIRED_MESSAGE = "Configure geofencing to search";

/** Full explanation shown when a search is attempted without geofencing. */
export const GEOFENCING_REQUIRED_DETAIL =
  "Embeddings search requires a geofencing area. Draw or import one to search.";

/** Short label shown on disabled search controls when the geofencing area is too large. */
export const GEOFENCING_AREA_TOO_LARGE_MESSAGE = "Geofencing area is too large to search";

/**
 * Builds the full explanation shown when the configured geofencing area is above the API limit.
 * @param formattedArea Human-readable current area, e.g. "2,500,000 km²"
 * @returns User-facing message including both the current area and the maximum allowed
 */
export function geofencingAreaTooLargeDetail(formattedArea: string): string {
  return (
    `The geofencing area (${formattedArea}) exceeds the ` +
    `${MAX_GEOFENCING_AREA_SQUARE_KILOMETERS.toLocaleString("en-US")} km² limit of the embeddings API. ` +
    `Reduce the area to search.`
  );
}
